import {useIntl} from 'react-intl';
import {Card} from 'react-bootstrap';
import InfoBanner from '../../Ticket/Components/InfoBanner';
import {downloadEligibiliteMasseTemplate} from '../Api/api';

const EligibiliteMasseGuide = (): JSX.Element => {
  const intl = useIntl();

  return (
    <Card className="mb-8">
      <Card.Body>
        <Card.Title className="fw-bold mb-4">
          {intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.TITLE'})}
        </Card.Title>

        <InfoBanner variant="info">
          <div className="fw-bold mb-2">
            {intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.FORMAT.TITLE'})}
          </div>
          <p className="mb-1">{intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.FORMAT.DELIMITER'})}</p>
          <p className="mb-1">{intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.FORMAT.COLUMNS'})}</p>
          <p className="mb-0">{intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.FORMAT.OPTIONAL'})}</p>
        </InfoBanner>

        <InfoBanner variant="warning">
          <p className="mb-0">{intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.LIMIT'})}</p>
        </InfoBanner>

        <InfoBanner variant="info">
          <p className="mb-0">{intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.PROCESSING'})}</p>
        </InfoBanner>

        <InfoBanner variant="success">
          <p className="mb-0">{intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.RESULT'})}</p>
        </InfoBanner>

        <button
          type="button"
          className="btn btn-sm btn-light-primary"
          onClick={downloadEligibiliteMasseTemplate}
        >
          <i className="fas fa-download me-2"></i>
          {intl.formatMessage({id: 'DIVOPS.MASSE.GUIDE.TEMPLATE.BUTTON'})}
        </button>
      </Card.Body>
    </Card>
  );
};

export default EligibiliteMasseGuide;
